module.exports = __webpack_public_path__ + "img/added-service-unit-01.bbb3ffb6.png";